import background from 'data/campaign/goblins/goblins_background.png'
import { goblins_missions } from 'data/campaign/goblins/goblins_missions'
import { default_env } from 'game/extended/default_env'
import { items } from 'game/extended/types'
import { keysof } from 'game/util/keysof'
import { CampaignModel } from 'models/campaign/CampaignModel'
import { ChapterConfig, Difficulty } from 'models/campaign/ChapterModel'

export const goblins_chapter: ChapterConfig = {
    label: 'Goblin Battlefields',
    background,
    missions: keysof(goblins_missions),
    classes: ['barbarian', 'mage', 'paladin', 'ranger'],
    items: keysof(items),
    initial: (difficulty: Difficulty) => new CampaignModel({
        user: {
            counter: 0,
            heros: [],
            inventory: [],
            money: difficulty === 'regular' ? 250 : 200
        },
        difficulty,
        chapter: 'goblins_chapter',
        missions: {}
    }, default_env).shuffleShop()
}
